export default function() {
  return {
    '/:page': {
      on: page => {
        window.location.assign(`/admin/${page}`);
      },
    },
  };
}



// WEBPACK FOOTER //
// ./src/scripts/adapters/routes/admin_routes.js